<div class="lum-c-invoice-client-form">
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <form [formGroup]="form">
        <div class="lum-c-invoice-client-form__fieldset">
          <div class="d-flex gap-2">
            <label class="form-group">
              <div class="lum-label">Customer PO Number</div>
              <input
                type="text"
                class="lum-input"
                matInput
                formControlName="customer_po_number"
                [ngClass]="{
                  error: form.get('customer_po_number')?.invalid,
                }"
              />
            </label>
            <label class="form-group lum-c-invoice-client-form__field">
              <div class="lum-label">Invoice Date</div>
              <mat-form-field class="lum-datepicker-field">
                <input
                  matInput
                  [matDatepicker]="orderDatepicker"
                  formControlName="order_date"
                />
                <mat-hint class="pt-4">{{ dateFormatHint }}</mat-hint>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="orderDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #orderDatepicker></mat-datepicker>
              </mat-form-field>
            </label>

            <ng-container
              *ngIf="'utah_FR-591_requested_ship_date_on_invoice' | featureFlag"
            >
              <label class="form-group lum-c-invoice-client-form__field">
                <div class="lum-label">Requested Ship Date</div>
                <mat-form-field class="lum-datepicker-field">
                  <input
                    matInput
                    [matDatepicker]="shipByDatepicker"
                    formControlName="ship_by_date"
                  />
                  <mat-hint class="pt-4">{{ dateFormatHint }}</mat-hint>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="shipByDatepicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #shipByDatepicker></mat-datepicker>
                </mat-form-field>
              </label>
            </ng-container>

            <button
              type="button"
              class="
                ml-auto lum-button lum-button--secondary lum-form__item--emulate-label
              "
              (click)="onOpenInvoiceAdvanceSettingsDialog()"
            >
              <lum-ui-icon icon="cog"></lum-ui-icon>
              Advanced Settings
            </button>
          </div>
        </div>

        <div class="row">
          <fieldset
            class="
              col-12 col-sm lum-c-invoice-client-form__fieldset lum-c-invoice-client-form__fieldset--client
            "
          >
            <div class="lum-c-invoice-client-form__fieldset-head">
              <legend class="lum-c-invoice-client-form__fieldset-title">
                Client
              </legend>
              <div class="lum-c-invoice-client-form__fieldset-actions">
                <button
                  *ngIf="currentCompany"
                  type="button"
                  class="lum-button lum-button--link"
                  (click)="handleAddPayMethod($event)"
                >
                  <lum-ui-icon
                    icon="money-atm-card"
                    width="19"
                    height="19"
                  ></lum-ui-icon>
                  Add Pay Profile
                </button>
                <button
                  *ngIf="currentCompany"
                  type="button"
                  class="lum-button lum-button--secondary"
                  (click)="onClearClient()"
                >
                  <lum-ui-icon
                    icon="close-circle"
                    width="19"
                    height="19"
                  ></lum-ui-icon>
                  Clear Client
                </button>
              </div>
            </div>

            <div class="flex gap-2">
              <label class="form-group grow">
                <div class="lum-label">Company</div>
                <lum-ui-autocomplete
                  [placeholder]="'Search companies'"
                  [options]="companies"
                  [debounceTime]="500"
                  [loading]="loadingCompanies"
                  [displayProperty]="'business_name'"
                  [control]="clientControl"
                  (inputChangeEvent)="onSearchClientChange($event)"
                  (optionSelectedEvent)="onSelectCompany($event)"
                  (scrollPaginate)="scrollPaginate.emit($event)"
                ></lum-ui-autocomplete>
              </label>

              <em
                *ngIf="!currentCompany"
                class="lum-form__item--emulate-label mx-2 pt-3 text-cloud-500"
                >- OR -</em
              >

              <lum-client-profile-create
                class="lum-form__item--emulate-label"
                [client]="currentCompany ?? null"
              ></lum-client-profile-create>
            </div>

            <div class="flex gap-2">
              <label
                *ngIf="!editContact; else editContactForm"
                class="form-group grow"
              >
                <div class="lum-label">Contact</div>
                <mat-select
                  class="lum-select"
                  formControlName="client_contact_id"
                  (selectionChange)="onSelectContact($event)"
                >
                  <mat-option *ngIf="shouldOverrideClientContact" value="">
                    {{ clientContactOverrideValue }}
                  </mat-option>
                  <mat-option
                    *ngFor="let contact of contacts; trackBy: trackById"
                    [value]="contact.id"
                  >
                    {{ contact?.userAccount?.fullName }}
                    <span
                      *ngIf="
                        contact?.userAccount?.email &&
                        contact?.userAccount?.phoneOne
                      "
                    >
                      [{{ contact?.userAccount?.email }} /
                      {{ contact?.userAccount?.phoneOne }}]
                    </span>
                    <span
                      *ngIf="
                        contact?.userAccount?.email &&
                        !contact?.userAccount?.phoneOne
                      "
                    >
                      [{{ contact?.userAccount?.email }}]
                    </span>
                    <span
                      *ngIf="
                        !contact?.userAccount?.email &&
                        contact?.userAccount?.phoneOne
                      "
                    >
                      [{{ contact?.userAccount?.phoneOne }}]
                    </span>
                  </mat-option>
                </mat-select>
              </label>
              <ng-template #editContactForm>
                <div class="flex gap-4">
                  <label class="form-group">
                    <div class="lum-label">Email</div>
                    <input
                      type="text"
                      class="lum-input"
                      matInput
                      formControlName="shipping_email"
                      [ngClass]="{
                        error: form.get('shipping_email')?.invalid,
                      }"
                    />

                    <mat-error *ngIf="form.get('shipping_email')?.invalid"
                      ><small class="text-red">
                        This field is required
                      </small></mat-error
                    >
                  </label>
                  <label class="form-group">
                    <div class="lum-label">Phone</div>
                    <input
                      type="text"
                      class="lum-input"
                      matInput
                      formControlName="shipping_phone"
                      [ngClass]="{
                        error: form.get('shipping_phone')?.invalid,
                      }"
                    />
                    <mat-error *ngIf="form.get('shipping_phone')?.invalid"
                      ><small class="text-red">
                        This field is required
                      </small></mat-error
                    >
                  </label>
                  <label class="form-group">
                    <div class="lum-label">Name</div>
                    <input
                      type="text"
                      class="lum-input"
                      matInput
                      formControlName="shipping_name"
                      [ngClass]="{
                        error: form.get('shipping_name')?.invalid,
                      }"
                      lumTextOnly
                    />
                    <mat-error *ngIf="form.get('shipping_name')?.invalid"
                      ><small class="text-red">
                        This field is required
                      </small></mat-error
                    >
                  </label>
                  <label class="form-group">
                    <div class="lum-label">Company</div>
                    <input
                      type="text"
                      class="lum-input"
                      matInput
                      formControlName="shipping_company"
                      [ngClass]="{
                        error: form.get('shipping_company')?.invalid,
                      }"
                      lumTextOnly
                    />
                    <mat-error *ngIf="form.get('shipping_company')?.invalid"
                      ><small class="text-red">
                        This field is required
                      </small></mat-error
                    >
                  </label>
                </div>
              </ng-template>

              <button
                type="button"
                class="lum-button lum-button--link lum-form__item--emulate-label"
                (click)="onOverrideContact()"
                [disabled]="!currentCompany"
              >
                <lum-ui-icon
                  icon="{{ !editContact ? 'edit' : 'check-circle' }}"
                ></lum-ui-icon>
                {{ !editContact ? 'Override' : 'Done' }}
              </button>
            </div>

            <div class="flex gap-2">
              <label [hidden]="editShipping" class="form-group grow">
                <div class="lum-label">Shipping Address</div>
                <lum-client-shipping-address-accessor
                  formControlName="shipping_address_id"
                  [businessAccountId]="currentCompany?.id"
                  [isUpdateMode]="!!currentInvoice?.id"
                  (selectedAddressEvent)="onSelectShippingAddresss($event)"
                  [overrideShippingAddress]="
                    form?.value | clientShippingAddressOverride
                  "
                >
                </lum-client-shipping-address-accessor>
              </label>
              <ng-container *ngIf="editShipping">
                <div class="shipping-form-block flex flex-col">
                  <div class="flex-auto flex flex-row gap-4">
                    <label class="form-group w-p40">
                      <div class="lum-label">Shipping Address Line 1</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="ship_address"
                        [ngClass]="{
                          error: form.get('ship_address')?.invalid,
                        }"
                      />
                      <mat-error *ngIf="form.get('ship_address')?.invalid"
                        ><small class="text-red">
                          This field is required
                        </small></mat-error
                      >
                    </label>
                    <label class="form-group w-p40">
                      <div class="lum-label">Shipping Address Line 2</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="ship_address_line_2"
                      />
                    </label>
                  </div>
                  <div class="flex-auto flex flex-row gap-4">
                    <label class="form-group">
                      <div class="lum-label">City</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="ship_city"
                        [ngClass]="{
                          error: form.get('ship_city')?.invalid,
                        }"
                      />
                      <mat-error *ngIf="form.get('ship_city')?.invalid"
                        ><small class="text-red">
                          This field is required
                        </small></mat-error
                      >
                    </label>
                    <label class="form-group">
                      <div class="lum-label">State</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="ship_state"
                        [ngClass]="{
                          error: form.get('ship_state')?.invalid,
                        }"
                      />
                      <mat-error *ngIf="form.get('ship_state')?.invalid"
                        ><small class="text-red">
                          This field is required
                        </small></mat-error
                      >
                    </label>
                    <label class="form-group">
                      <div class="lum-label">Country</div>

                      <mat-select
                        class="lum-select w-49"
                        formControlName="ship_country"
                        [ngClass]="{
                          error: form.get('ship_country')?.invalid,
                        }"
                      >
                        <mat-option
                          *ngFor="let country of countries; trackBy: trackByValue"
                          [value]="country?.key"
                          >{{ country?.value }}</mat-option
                        >
                      </mat-select>
                      <mat-error *ngIf="form.get('ship_country')?.invalid"
                        ><small class="text-red">
                          This field is required
                        </small></mat-error
                      >
                    </label>
                    <label class="form-group">
                      <div class="lum-label">Zip</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="ship_zip"
                        [ngClass]="{
                          error: form.get('ship_zip')?.invalid,
                        }"
                      />
                      <mat-error *ngIf="form.get('ship_zip')?.invalid"
                        ><small class="text-red">
                          This field is required
                        </small></mat-error
                      >
                    </label>
                  </div>
                  <div class="flex-auto flex flex-row gap-4">
                    <label class="form-group">
                      <div class="lum-label">Shipping Account #</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="shipping_account_number"
                        [ngClass]="{
                          error: form.get('shipping_account_number')?.invalid,
                        }"
                      />
                    </label>

                    <label class="form-group">
                      <div class="lum-label">Shipping Type</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="shipping_type"
                        [ngClass]="{
                          error: form.get('shipping_type')?.invalid,
                        }"
                      />
                    </label>

                    <label class="form-group w-p40">
                      <div class="lum-label">Shipping Notes</div>
                      <input
                        type="text"
                        class="lum-input"
                        matInput
                        formControlName="shipping_notes"
                        [ngClass]="{
                          error: form.get('shipping_notes')?.invalid,
                        }"
                      />
                    </label>
                  </div>
                </div>
              </ng-container>
              <button
                type="button"
                class="
                  lum-button lum-button--link lum-form__item--emulate-label ml-auto
                "
                (click)="onOverrideShipping()"
                [disabled]="!currentCompany"
              >
                <lum-ui-icon
                  icon="{{ !editShipping ? 'edit' : 'check-circle' }}"
                ></lum-ui-icon>
                {{ !editShipping ? 'Override' : 'Done' }}
              </button>
            </div>
          </fieldset>

          <fieldset
            class="
              col-12 col-sm lum-c-invoice-client-form__fieldset lum-c-invoice-client-form__fieldset--notes
            "
          >
            <div class="lum-c-invoice-client-form__fieldset-head">
              <legend class="lum-c-invoice-client-form__fieldset-title">
                Notes
              </legend>

              <div class="lum-c-invoice-client-form__fieldset-actions">
                <button
                  type="button"
                  class="lum-button lum-button--link"
                  (click)="onOpenInvoiceNoteDialog()"
                >
                  <lum-ui-icon icon="edit-pencil"></lum-ui-icon>
                  Invoice Notes
                </button>
              </div>
            </div>

            <label
              *ngIf="currentCompany?.meta_data?.client_po_notes"
              class="form-group d-block"
            >
              <div class="lum-label">Client Invoice Notes</div>
              <lum-ui-alert
                [message]="currentCompany?.meta_data?.client_po_notes || ''"
                type="warning"
              ></lum-ui-alert>
            </label>
          </fieldset>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
